import { render, staticRenderFns } from "./VerifyChangeEmail.vue?vue&type=template&id=153f1be4&scoped=true"
import script from "./VerifyChangeEmail.vue?vue&type=script&lang=js"
export * from "./VerifyChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyChangeEmail.vue?vue&type=style&index=0&id=153f1be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f1be4",
  null
  
)

export default component.exports